import React from 'react';
import {Box, Card, CardContent, CardHeader, Divider, Grid, TextField} from "@mui/material";
import * as Yup from 'yup';
import {useParams} from 'react-router-dom';
import useAuth from "../../../hooks/useAuth";
import GeneralEditor, {MODE_CREATE, MODE_EDIT} from "../../../components/CrudFrom/GeneralEditor";
import {executeMutationUtil, executeQueryUtil} from "../../../utils/gqlUtil";
import {
  addDataProjectToCache,
  createProjectMutation,
  getProjectQuery,
  updateProjectMutation
} from "../../../gql/projectGql";
import localStrings from "../../../localStrings";
import {getAppRoute, projectsRoute} from "../../../routes";
import {useNavigate} from "react-router";
import { uuid } from 'uuidv4';
import TextFieldPassword from "../../../components/TextFieldPassword";

export const getProject = async (brandId, projectId, modeEdit) => {
  if (modeEdit == MODE_CREATE) {
    return null;
  }
  if (!modeEdit || modeEdit == MODE_EDIT) {
    var items =  await executeQueryUtil(getProjectQuery(brandId, projectId));
    return items;
  }
  return null;
}

export const saveFormProject = async (item, values, modeEdit, brandId, navigate) => {
  let data;
  let intDuration = parseInt(values.durationInactivityTouchScreen);
  delete values.changeChromeAddressUrl;
  delete values.printTicketUrl;
  delete values.rebootUrl;
  delete values.durationInactivityTouchScreen;
  if (!values.authKey) {
    values.authKey = uuid();
  }
  if (!modeEdit || modeEdit == MODE_EDIT) {
    data = {
      ...item,
      ...values,
      durationInactivityTouchScreen: intDuration
    };
    await executeMutationUtil(updateProjectMutation(brandId, data));
  }

  else if (modeEdit == MODE_CREATE){
    data = {...values};
    const projectCreated = await executeMutationUtil(createProjectMutation(brandId, data));
    await addDataProjectToCache(brandId, [projectCreated.data?.addProject]);
  }
  if (navigate) {
    navigate(getAppRoute(projectsRoute))
  }

  return data;
}

const ProjectCreateUpdateForm = ({className, modeEdit}) => {
  let {projectId} = useParams();
  const { currentBrand } = useAuth();
  const navigate = useNavigate();


  const buildFormValues = (item) => {
    return {
      initialValues: {
        name: item.name || '',
        authKey: item.authKey || '',
      },
      validationSchema: {
        name: Yup.string().max(255).required(localStrings.check.fieldRequired),
      }
    };
  }

  const getCardContentForm = ({
                                errors,
                                handleBlur,
                                handleChange,
                                handleSubmit,
                                isSubmitting,
                                setFieldValue,
                                touched,
                                values
                              }) => {
    return (
      <Grid
        container
        spacing={4}
      >
        <Grid
          item
          md={12}
          xs={12}
        >
          <TextField
            inputProps={{
              autocomplete:"new-password"
            }}
            error={Boolean(touched.name && errors.name)}
            fullWidth
            helperText={touched.name && errors.name}
            label={localStrings.projectName}
            name="name"
            onBlur={handleBlur}
            onChange={handleChange}
            required
            value={values.name}
            variant="outlined"
          />
        </Grid>
        {modeEdit == MODE_EDIT &&
          <Grid
            item
            md={12}
            xs={12}
          >
            <TextFieldPassword
              inputProps={{
                autocomplete: "new-password"
              }}
              error={Boolean(touched.authKey && errors.authKey)}
              fullWidth
              helperText={touched.authKey && errors.authKey}
              label={localStrings.authKey}
              name="authKey"
              onBlur={handleBlur}
              onChange={handleChange}
              disabled
              value={values.authKey}
              variant="outlined"
            />
          </Grid>
        }
      </Grid>
    );
  }




  return <GeneralEditor getItemFunction={() => getProject(currentBrand().id, projectId, modeEdit)}
                        className={className}
                        buildFormValues={buildFormValues}
                        getCardContentForm={getCardContentForm}
                        saveForm={(item, values) => saveFormProject(item, values, modeEdit, currentBrand().id, navigate)}
                        applyButton={modeEdit == MODE_CREATE ? localStrings.create : localStrings.update}
                        resetFormProp={modeEdit == MODE_CREATE}
                        messageSuccess={modeEdit == MODE_CREATE ?
                          localStrings.notif.projectCreated : localStrings.notif.projectUpdated}
                        titleForm={modeEdit == MODE_CREATE ? localStrings.createProject : localStrings.general}
                        getPathToData={(result) => {
                          return  result.data.getProject;
                        }}
  />
};

export default ProjectCreateUpdateForm;
